import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { usePageTitle } from "@/hooks/usePageTitle";

const API = process.env.REACT_APP_BACKEND_URL;

export default function DatenschutzPage() {
  usePageTitle("Datenschutz");
  const [html, setHtml] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/erecht24/datenschutz`)
      .then((r) => r.json())
      .then((data) => setHtml(data.html_de || null))
      .catch(() => setHtml(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="py-12 md:py-24 px-4 md:px-8" data-testid="datenschutz-page">
      <div className="max-w-3xl mx-auto">
        {loading ? (
          <p className="text-muted-foreground" data-testid="datenschutz-loading">Lade Datenschutzerklärung…</p>
        ) : html ? (
          <>
            <style>{`
              .erecht24-content h1 { font-family: Oswald; font-size: 2.25rem; font-weight: 700; text-transform: uppercase; letter-spacing: -0.025em; margin-bottom: 2rem; }
              .erecht24-content h1::first-letter { color: #fbbf24; }
              .erecht24-content h2 { font-family: Oswald; font-size: 1.125rem; font-weight: 700; text-transform: uppercase; color: #fbbf24; margin-top: 2.5rem; margin-bottom: 0.75rem; }
              .erecht24-content h3 { font-size: 1rem; font-weight: 600; margin-top: 1.5rem; margin-bottom: 0.5rem; color: #e2e8f0; }
              .erecht24-content h4 { font-size: 0.875rem; font-weight: 600; margin-top: 1rem; margin-bottom: 0.25rem; color: #cbd5e1; }
              .erecht24-content p { margin-bottom: 0.5rem; color: #94a3b8; }
              .erecht24-content ul, .erecht24-content ol { margin-left: 1.5rem; margin-bottom: 0.75rem; color: #94a3b8; }
              .erecht24-content li { margin-bottom: 0.25rem; }
              .erecht24-content a { color: #fbbf24; text-decoration: underline; }
              .erecht24-content a:hover { color: #f59e0b; }
              @media (min-width: 640px) { .erecht24-content h1 { font-size: 3rem; } }
              @media (min-width: 1024px) { .erecht24-content h1 { font-size: 3.75rem; } }
            `}</style>
            <div
              data-testid="datenschutz-content"
              className="erecht24-content max-w-none text-sm leading-relaxed"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
            />
          </>
        ) : (
          <div data-testid="datenschutz-fallback">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight mb-8" style={{ fontFamily: 'Oswald' }}>
              Daten<span style={{ color: '#fbbf24' }}>schutz</span>
            </h1>
            <p className="text-muted-foreground">Die Datenschutzerklärung konnte nicht geladen werden.</p>
          </div>
        )}
      </div>
    </div>
  );
}
